import React from 'react';
import AsyncPage from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default [
  <BlankLayout
    key="/perfectbeauty/youcam/terms-of-service-yca"
    exact
    path="/perfectbeauty/youcam/terms-of-service-yca"
    component={AsyncPage}
  />,
];
